import React from 'react';

const NotAvailable = ({ beach }) => (
  <div className="container page">
    <h1>
      <i className="far fa-calendar-exclamation" /> Sorry, there are currently
      no available schedules for {beach}. Please check back later.{' '}
    </h1>
  </div>
);

export default NotAvailable;
